var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 36,
    viewBox: "0 0 82 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7116 36C59.0257 36 54.3399 34.2437 50.7725 30.7332L45.7437 25.7846C44.8699 24.9247 44.8699 23.5317 45.7437 22.6718C46.6175 21.812 48.0331 21.812 48.9069 22.6718L53.9358 27.6205C59.3272 32.9238 68.0959 32.9259 73.4874 27.6226C78.8745 22.3171 78.8745 13.6872 73.4874 8.38277C68.0959 3.0816 59.3272 3.0773 53.9358 8.38062L31.2275 30.7311C24.0938 37.752 12.483 37.752 5.34939 30.7311C-1.78313 23.7101 -1.78313 12.2866 5.34939 5.2657C12.4841 -1.75523 24.0927 -1.75523 31.2275 5.2657L36.2563 10.2143C37.1301 11.0742 37.1301 12.4672 36.2563 13.3271C35.3825 14.187 33.9669 14.187 33.0931 13.3271L28.0642 8.37847C22.6728 3.07515 13.9041 3.07515 8.51261 8.37847C3.12444 13.6829 3.12444 22.3128 8.51261 27.6183C13.9019 32.9238 22.6728 32.9238 28.0642 27.6183L50.7725 5.26785C57.9072 -1.75093 69.5159 -1.75093 76.6506 5.27C83.7831 12.2909 83.7831 23.7144 76.6506 30.7354C73.0833 34.2437 68.3974 36 63.7116 36Z",
    fill: "url(#paint0_radial_23692_74643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_23692_74643",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41 18) rotate(23.782) scale(32.2374 73.4296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.20e597464760d43bfdb595cb459ca3ac.svg";
export { ForwardRef as ReactComponent };